import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoggedIn: false,
  userToken: '',
  user_id: null,
  user_name: '',
  label_name: '',
  sysAdmin: false,
  drawerOpen: false,
  partyFilterList: [],
  openAlert: false,
  alertNo: 0,
  alertData: [],
  activeCategory: [],
  partyId: null,
  urlPartyId: null,

  drawerLevel1Id: '',
  drawerLevel2Id: '',
  drawerLevel3Id: '',
  drawerLevel4Id: '',
  partyData: [],
};

export const appStateSlice = createSlice({
  name: 'appStateReducer',
  initialState,
  reducers: {
    resetAppState: (state, action) => {
      return {
        ...initialState,
      };
    },

    setToken: (state, action) => {
      state.userToken = action.payload;
    },
    setPartyFilterList: (state, action) => {
      state.partyFilterList = action.payload;
    },
    setOpenDrawer: (state, action) => {
      state.drawerOpen = action.payload;
    },
    setLabelName: (state, action) => {
      state.label_name = action.payload;
    },
    setPartyId: (state, action) => {
      state.partyId = action.payload;
    },
    setURLPartyId: (state, action) => {
      state.urlPartyId = action.payload;
    },
    setDrawerLevel1: (state, action) => {
      state.drawerLevel1Id = action.payload;
    },
    setDrawerLevel2: (state, action) => {
      state.drawerLevel2Id = action.payload;
    },
    setDrawerLevel3: (state, action) => {
      state.drawerLevel3Id = action.payload;
    },
    setDrawerLevel4: (state, action) => {
      state.drawerLevel4Id = action.payload;
    },
    setOpenAlert: (state, action) => {
      state.openAlert = action.payload;
    },
    setAlertNo: (state, action) => {
      state.alertNo = action.payload;
    },
    setAlertData: (state, action) => {
      state.alertData = action.payload;
    },
    setSelectedCategory: (state, action) => {
      state.activeCategory = action.payload;
    },
    setPartyData: (state, action) => {
      state.partyData = action.payload;
    },
  },
});

export const {
  resetAppState,
  setPartyId,
  setURLPartyId,
  setToken,
  setOpenDrawer,
  setOpenAlert,
  setLabelName,
  setAlertNo,
  setAlertData,
  changeDrawerOpen,
  setSelectedCategory,
  setDrawerLevel1,
  setDrawerLevel2,
  setDrawerLevel3,
  setDrawerLevel4,
  setPartyFilterList,
  setPartyData,
} = appStateSlice.actions;

export default appStateSlice.reducer;
